import { render, staticRenderFns } from "./SuggestionList.vue?vue&type=template&id=43778eaa&scoped=true"
import script from "./SuggestionList.vue?vue&type=script&lang=ts"
export * from "./SuggestionList.vue?vue&type=script&lang=ts"
import style0 from "./SuggestionList.vue?vue&type=style&index=0&id=43778eaa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43778eaa",
  null
  
)

export default component.exports